<template>
  <k-layout row v-if="show_doughnut_chart" class="elevation-1">
      <k-flex c6>
      <k-layout v-if="total_sum != 0" class="report-card">
        <k-flex c6>
          <div>
            <h2>Billables</h2>
            <h3>Total: {{total_sum.toFixed(2)}}</h3>
            <h3>Billed: {{billed_sum.toFixed(2)}}</h3>
            <h3>Unbilled: {{unbilled_sum.toFixed(2)}}</h3>
          </div>
          <div>
            <div v-for="(billable, index) in sorted_billables_info" :key="index" >
              <div v-if="billable.type == 'custom'">
                <h3>{{billable.name}} - {{billable.type}}</h3>
                <p>{{billable.sum}}€</p>
              </div>
              <div v-else>
                <h3>{{billable.name}} - {{billable.type}}</h3>
                <p>{{billable.sum}}€</p>
                <p>{{billable.number + "kpl, per " + billable.price}}€</p>
              </div>
            </div>
          </div>
        </k-flex>
        <k-flex c6>
          <Doughnut
            :chart-data="billables_chart_data" 
            :chart-options="chart_options"
            class="doughnut-style"
          ></Doughnut>
        </k-flex>
      </k-layout>
    </k-flex>
    <k-flex c6>
      <k-layout v-if="expenses_sum != 0" class="report-card">
        <k-flex c6>
          <div>
            <h2>Expenses</h2>
            <h3>Total: {{expenses_sum.toFixed(2)}}</h3>
          </div>
          <div>
            <div v-for="(expense, index) in sorted_expenses_info" :key="index">
              <h3>{{expense.name}} - {{expense.type}}</h3>
              <p>{{expense.sum}}€</p>
            </div>
          </div>
        </k-flex>
        <k-flex c6>
          <Doughnut
            :chart-data="expenses_chart_data" 
            :chart-options="chart_options"
            class="doughnut-style"
          ></Doughnut>
        </k-flex>
      </k-layout>
      </k-flex>
    </k-layout>
</template>

<script>

import palette from 'google-palette';
import { Chart, ArcElement } from "chart.js"
import { Doughnut } from 'vue-chartjs/legacy';

Chart.register(ArcElement);

export default {
  name: 'chart',
  components: {
    Doughnut
  },
  props: {
    show_doughnut_chart: { type: Boolean, default: false },
    total_sum: { type: Number, default: 0 },
    billed_sum: { type: Number, default: 0 },
    unbilled_sum: { type: Number, default: 0 },
    expenses_sum: { type: Number, default: 0 },
    billables_info: { type: Object, default: () => ({}) },
    expenses_info: { type: Object, default: () => ({}) },
    sorted_billables_info: { type: Object, default: () => ({}) },
    sorted_expenses_info: { type: Object, default: () => ({}) }
  },
  computed: {
    billables_chart_data() {
      return this.build_chart_data(this.billables_info);
    },
    expenses_chart_data() {
      return this.build_chart_data(this.expenses_info);
    },
    chart_options() {
      return {
        radius: '90%',
        responsive: true,
        hoverOffset: 6,
        borderWidth: 2,
      }
    },
  },
  methods: {
    build_chart_data(info) {
      var labels = [];
      var datasets = [];
      // Get data from the provided info object
      var data = [];
      for (var key in info) {
        data = info[key];
        labels.push(data.name);
        datasets.push(data.sum);
      }

      // Colors
      var background_color = palette('tol', labels.length).map(function(hex) {
        return '#' + hex;
      });
      var rgb_background_color = [];
      var rgb_border_color = [];

      // Hexes to RGB, background 0.4 opacity, borders 1.0
      var color = "";
      for (var index in background_color) {
        var c;
        color = background_color[index];
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)) {
          c = color.substring(1).split('');
          if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
          }
          c = '0x' + c.join('');
          rgb_background_color.push('rgba(' + [(c>>16)&255, (c>>8)&255, c&255].join(',') + ',' + String(0.4) + ')');
          rgb_border_color.push('rgba(' + [(c>>16)&255, (c>>8)&255, c&255].join(',') + ',' + String(1) + ')');
        }
      }

      return {
        labels: labels,
        datasets: [{
          data: datasets,
          backgroundColor: rgb_background_color,
          borderColor: rgb_border_color,
          borderWidth: 1
        }]
      }
    }
  }
}
</script>

<style scoped>
.report-card {
  width: 50% !important;
}
</style>